
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[level_zero]",
      function () {
        return require("private-next-pages/[level_zero]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[level_zero]"])
      });
    }
  